import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import GeneralDisclosureService from "../../../core/service/GeneralDisclosureService";
import ESGDataSetService from "../../../core/service/ESGDataSetService";
import { LS_AUTHORITY_KEY, USER_ROLE } from "../../../core/constants/common";

const DisclosureFormPopup = ({ t, saveCallback, disclosureId, disclosureName, discStandardType}) => {
  const [show, setShow] = useState(true);
  const [validated, setValidated] = useState(false);
  const [name, setName] = useState(disclosureName ?? null);
  const [stdType, setStdType] = useState(discStandardType ?? null);
	const [standards, setStandards] = useState([]);
	const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));

  useEffect(() => {
		getStandards();
	}, []);

	const getStandards = () => {
		ESGDataSetService.getPlatformStandard().then(res => {
			if (res.status !== 200) return;

			setStandards(res.data.data ?? []);
		}).catch(err => {});
	};

  const handleClose = () => {
    setShow(false);
    saveCallback(false);
  };

  const handleSave = () => {
    let req;
    if (disclosureId > 0) {
      req = GeneralDisclosureService.updateDisclosure(disclosureId, { name: name, standardType: stdType }, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    } else {
      req = GeneralDisclosureService.createDisclosure({ name: name, standardType: stdType }, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    }
    req?.then((response) => {
      setShow(false);
      if (response.status !== 201 && response.status !== 200) return;

      saveCallback(true);
    }).catch((error) => {
      setShow(false);
      saveCallback(false);
    });
    setValidated(true);
  };

  return (
    <>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {disclosureId > 0 ? t("EditUniversalStandard.label") : t("NewUniversalStandard.label")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
                <div className="p-2">
                  <label className="mb-1">{t("Name.label")} *</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Standard.label")} *</label>
                  <select className="form-select"
                    onChange={(e) => setStdType(e.target.value)}
                    value={stdType}>
                      <option value={''}>{t('Select.label')}</option>
                  {
                    standards?.map((s, index) => {
                      return <option key={`std-${index}`} value={s}>{s}</option>
                    })
                  }
                  </select>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" onClick={handleSave} className="sbmBtn">
              {disclosureId > 0 ? t("Update.label") : t("Create.label")}
            </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default withTranslation()(DisclosureFormPopup);
